module.exports = __webpack_public_path__ + "img/Al-Arasat1.5c60dae1.png";